/* MCR · Product help: selfie colour match.
   Camera (front, full screen) or upload → on-device skin-tone estimate → best colours + real MCR picks
   → compare any pick side by side with the photo. Nothing is uploaded. */
(function () {
  if (window.__mcrHelp) return;
  window.__mcrHelp = true;

  var TONES = {
    fair: {
      label: 'Fair',
      why: 'Deep, rich shades add contrast to a lighter complexion.',
      colors: [['Navy', '#1c2b4f', 'navy'], ['Maroon', '#7c0f24', 'maroon'], ['Bottle green', '#1f5c3f', 'green'], ['Charcoal', '#4a4f57', 'grey'], ['Purple', '#5b2a6e', 'violet']]
    },
    wheatish: {
      label: 'Wheatish',
      why: 'Warm and soft shades glow on wheatish skin.',
      colors: [['White', '#fbfaf6', 'white'], ['Sky blue', '#8fb8dc', 'blue'], ['Olive', '#6b7040', 'olive'], ['Peach', '#f2b894', 'peach'], ['Mustard', '#d4a017', 'mustard']]
    },
    dusky: {
      label: 'Dusky',
      why: 'Bright and light shades stand out beautifully on dusky skin.',
      colors: [['White', '#fbfaf6', 'white'], ['Cream', '#efe4cc', 'cream'], ['Light pink', '#f0b7c4', 'pink'], ['Royal blue', '#2c4fb3', 'blue'], ['Yellow', '#f2cd2f', 'yellow']]
    }
  };

  function fmtMoney(amount, format) {
    var n = parseFloat(amount);
    var f = format || 'Rs. {{amount}}';
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k.indexOf('no_decimals') > -1) return Math.round(n).toLocaleString('en-IN');
      return n.toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    });
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }

  /* Skin-tone estimate: average skin-like pixels in the central face oval → ITA angle. */
  function estimateTone(canvas) {
    var ctx = canvas.getContext('2d');
    var w = canvas.width, h = canvas.height;
    var d = ctx.getImageData(0, 0, w, h).data;
    var cx = w / 2, cy = h * 0.45, rx = w * 0.2, ry = h * 0.2;
    var r = 0, g = 0, b = 0, n = 0;
    for (var y = Math.floor(cy - ry); y < cy + ry; y += 2) {
      for (var x = Math.floor(cx - rx); x < cx + rx; x += 2) {
        if (((x - cx) * (x - cx)) / (rx * rx) + ((y - cy) * (y - cy)) / (ry * ry) > 1) continue;
        var i = (y * w + x) * 4, R = d[i], G = d[i + 1], B = d[i + 2];
        var Cb = 128 - 0.168736 * R - 0.331264 * G + 0.5 * B;
        var Cr = 128 + 0.5 * R - 0.418688 * G - 0.081312 * B;
        if (Cr < 133 || Cr > 180 || Cb < 77 || Cb > 135) continue;
        r += R; g += G; b += B; n++;
      }
    }
    if (n < 40) return null;
    r /= n; g /= n; b /= n;
    // sRGB → Lab (D65)
    function lin(c) { c /= 255; return c > 0.04045 ? Math.pow((c + 0.055) / 1.055, 2.4) : c / 12.92; }
    var R1 = lin(r), G1 = lin(g), B1 = lin(b);
    var X = (R1 * 0.4124 + G1 * 0.3576 + B1 * 0.1805) / 0.95047;
    var Y = R1 * 0.2126 + G1 * 0.7152 + B1 * 0.0722;
    var Z = (R1 * 0.0193 + G1 * 0.1192 + B1 * 0.9505) / 1.08883;
    function fx(t) { return t > 0.008856 ? Math.cbrt(t) : 7.787 * t + 16 / 116; }
    var L = 116 * fx(Y) - 16, bb = 200 * (fx(Y) - fx(Z));
    var ita = Math.atan2(L - 50, bb) * 180 / Math.PI;
    return ita > 38 ? 'fair' : ita > 18 ? 'wheatish' : 'dusky';
  }

  // Tone palettes come from the block settings (Name|#hex|search word per line); built-ins are the fallback.
  function readTones(dlg) {
    var el = dlg.querySelector('[data-match-tones]');
    if (!el) return;
    try {
      var cfg = JSON.parse(el.textContent);
      Object.keys(cfg).forEach(function (k) {
        if (!TONES[k] || !cfg[k]) return;
        var rows = String(cfg[k].list || '').split(/\r?\n/).map(function (r) { return r.split('|').map(function (x) { return x.trim(); }); })
          .filter(function (r) { return r[0] && /^#[0-9a-f]{3,8}$/i.test(r[1] || ''); })
          .map(function (r) { return [r[0], r[1], r[2] || r[0].toLowerCase()]; });
        if (rows.length) TONES[k].colors = rows;
        if (cfg[k].why) TONES[k].why = cfg[k].why;
      });
    } catch (e) {}
  }

  function Match(dlg) {
    this.dlg = dlg;
    readTones(dlg);
    this.video = dlg.querySelector('[data-cam-video]');
    this.canvas = dlg.querySelector('[data-match-canvas]');
    this.facing = 'user';
    this.cache = {};
    var self = this;
    dlg.addEventListener('click', function (e) { self.onClick(e); });
    dlg.addEventListener('change', function (e) {
      var inp = e.target.closest('[data-match-upload], [data-match-native]');
      if (inp && inp.files && inp.files[0]) self.fromFile(inp.files[0]);
      if (inp) inp.value = '';
    });
    dlg.addEventListener('close', function () { self.stop(); self.show('start'); document.body.classList.remove('overflow-hidden'); });
  }
  Match.prototype.show = function (step) {
    this.dlg.querySelectorAll('[data-step]').forEach(function (el) { el.hidden = el.dataset.step !== step; });
    this.dlg.classList.toggle('is-camera', step === 'camera');
    this.dlg.classList.toggle('is-result', step === 'result');
  };
  Match.prototype.onClick = function (e) {
    var t = e.target;
    if (t === this.dlg || t.closest('[data-mcr-match-close]')) { this.dlg.close(); return; }
    if (t.closest('[data-match-camera]')) { this.camera(); return; }
    if (t.closest('[data-cam-cancel]')) { this.stop(); this.show(this.photo ? 'result' : 'start'); return; }
    if (t.closest('[data-cam-flip]')) { this.facing = this.facing === 'user' ? 'environment' : 'user'; this.camera(); return; }
    if (t.closest('[data-cam-shoot]')) { this.shoot(); return; }
    if (t.closest('[data-match-retake]')) { this.show('start'); return; }
    var tone = t.closest('[data-tone]');
    if (tone) { this.setTone(tone.dataset.tone, false); return; }
    var cmp = t.closest('[data-compare]');
    if (cmp) {
      this.dlg.querySelector('[data-match-pimg]').src = cmp.dataset.compare;
      this.dlg.querySelector('[data-match-pname]').textContent = cmp.dataset.name;
      this.dlg.querySelectorAll('[data-compare]').forEach(function (b) { b.classList.toggle('is-active', b === cmp); });
      this.dlg.querySelector('.mcr-match__compare').scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
  };
  Match.prototype.camera = function () {
    var self = this;
    this.stop();
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) { this.dlg.querySelector('[data-match-native]').click(); return; }
    this.show('camera');
    navigator.mediaDevices.getUserMedia({ video: { facingMode: this.facing, width: { ideal: 1280 }, height: { ideal: 1280 } }, audio: false })
      .then(function (stream) {
        self.stream = stream;
        self.video.srcObject = stream;
        self.video.classList.toggle('is-mirror', self.facing === 'user');
        return self.video.play();
      })
      .catch(function () {
        // permission denied / no camera → fall back to the phone's own camera picker
        self.show('start');
        self.dlg.querySelector('[data-match-native]').click();
      });
  };
  Match.prototype.stop = function () {
    if (this.stream) { this.stream.getTracks().forEach(function (t) { t.stop(); }); this.stream = null; }
  };
  Match.prototype.shoot = function () {
    var v = this.video;
    if (!v.videoWidth) return;
    // crop to 3:4 portrait around the centre
    var vw = v.videoWidth, vh = v.videoHeight, tw = Math.min(vw, vh * 0.75), th = tw / 0.75;
    var c = this.canvas; c.width = 600; c.height = 800;
    var ctx = c.getContext('2d');
    ctx.save();
    if (this.facing === 'user') { ctx.translate(c.width, 0); ctx.scale(-1, 1); }
    ctx.drawImage(v, (vw - tw) / 2, (vh - th) / 2, tw, th, 0, 0, c.width, c.height);
    ctx.restore();
    this.stop();
    this.finish();
  };
  Match.prototype.fromFile = function (file) {
    var self = this;
    var img = new Image();
    var url = URL.createObjectURL(file);
    img.onload = function () {
      var c = self.canvas; c.width = 600; c.height = 800;
      var s = Math.max(c.width / img.width, c.height / img.height);
      var w = img.width * s, h = img.height * s;
      c.getContext('2d').drawImage(img, (c.width - w) / 2, (c.height - h) / 2, w, h);
      URL.revokeObjectURL(url);
      self.finish();
    };
    img.src = url;
  };
  Match.prototype.finish = function () {
    this.photo = this.canvas.toDataURL('image/jpeg', 0.88);
    this.dlg.querySelector('[data-match-selfie]').src = this.photo;
    var tone = estimateTone(this.canvas);
    this.show('result');
    this.setTone(tone || 'wheatish', true, !tone);
    this.dlg.querySelector('.mcr-match__box').scrollTop = 0;
  };
  Match.prototype.setTone = function (tone, auto, unsure) {
    var info = TONES[tone];
    this.dlg.querySelectorAll('[data-tone]').forEach(function (b) { b.setAttribute('aria-checked', b.dataset.tone === tone); });
    var det = this.dlg.querySelector('[data-match-detect]');
    if (auto) det.innerHTML = unsure
      ? 'We couldn’t read your skin tone clearly — pick the closest one:'
      : 'From your photo, your tone looks <strong>' + info.label + '</strong>. Not quite right? Pick another:';
    this.dlg.querySelector('[data-match-why]').textContent = info.why;
    // let MCR · Style match re-rank its looks for this tone
    document.dispatchEvent(new CustomEvent('mcr:tone', { detail: { tone: tone, label: info.label, colors: info.colors.map(function (c) { return c[0]; }) } }));
    var search = (window.routes && window.routes.search_url) || '/search';
    var kw = this.dlg.dataset.keyword || '';
    this.dlg.querySelector('[data-match-swatches]').innerHTML = info.colors.map(function (c) {
      return '<li><a href="' + search + '?type=product&q=' + encodeURIComponent(c[2] + ' ' + kw) + '"><i style="background:' + c[1] + '"></i>' + c[0] + '</a></li>';
    }).join('');
    this.picks(tone);
  };
  Match.prototype.picks = function (tone) {
    var self = this;
    var list = this.dlg.querySelector('[data-match-picks]');
    var empty = this.dlg.querySelector('[data-match-empty]');
    var kw = this.dlg.dataset.keyword || '';
    var base = this.dlg.dataset.searchUrl || '/search/suggest';
    var current = this.dlg.dataset.productUrl;
    list.innerHTML = '<li class="mcr-match__loading">Finding your picks…</li>';
    empty.hidden = true;
    var colors = TONES[tone].colors.slice(0, 4);
    Promise.all(colors.map(function (c) {
      var q = c[2] + ' ' + kw;
      if (self.cache[q]) return Promise.resolve(self.cache[q]);
      return fetch(base + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=hide')
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (j) { var p = (j && j.resources && j.resources.results && j.resources.results.products) || []; p.forEach(function (x) { x._c = c; }); self.cache[q] = p; return p; })
        .catch(function () { return []; });
    })).then(function (groups) {
      var seen = {}, out = [];
      // round-robin across colours so every recommended shade shows up
      for (var i = 0; i < 4; i++) groups.forEach(function (g) { var p = g[i]; if (p && !seen[p.url] && p.url.split('?')[0] !== current) { seen[p.url] = 1; out.push(p); } });
      out = out.slice(0, 8);
      if (!out.length) { list.innerHTML = ''; empty.hidden = false; return; }
      var fmt = self.dlg.dataset.moneyFormat;
      list.innerHTML = out.map(function (p) {
        var img = p.featured_image && p.featured_image.url ? p.featured_image.url : p.image;
        var sized = img ? img + (img.indexOf('?') > -1 ? '&' : '?') + 'width=400' : '';
        return '<li class="mcr-match__pick">' +
          '<a class="mcr-match__pick-img" href="' + esc(p.url) + '">' + (sized ? '<img src="' + esc(sized) + '" alt="" loading="lazy" width="200" height="250">' : '') +
          '<span class="mcr-match__pick-tag"><i style="background:' + p._c[1] + '"></i>' + esc(p._c[0]) + '</span></a>' +
          '<a class="mcr-match__pick-name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="mcr-match__pick-price">' + esc(fmtMoney(p.price, fmt)) + '</span>' +
          '<button type="button" class="mcr-match__pick-cmp" data-compare="' + esc(sized) + '" data-name="' + esc(p.title) + '">See with my photo</button></li>';
      }).join('');
    });
  };

  document.addEventListener('click', function (e) {
    var open = e.target.closest('[data-mcr-match-open]');
    if (!open) return;
    var help = open.closest('.mcr-help');
    var d = help && help.nextElementSibling && help.nextElementSibling.matches('[data-mcr-match]') ? help.nextElementSibling : document.querySelector('[data-mcr-match]');
    if (!d || !d.showModal) return;
    if (!d.__match) d.__match = new Match(d);
    d.__match.show(d.__match.photo ? 'result' : 'start');
    d.showModal();
    document.body.classList.add('overflow-hidden');
  });
})();
